import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import styles from './SbSharedNullSearchResultsHeader.scss';
import { SbSharedNullSearchResultsHeader_itemSearch$key } from './__generated__/SbSharedNullSearchResultsHeader_itemSearch.graphql';

type Props = { itemSearch: SbSharedNullSearchResultsHeader_itemSearch$key };

export const SbSharedNullSearchResultsHeader: FC<Props> = function ({ itemSearch: itemSearchRef }) {
    const itemSearch = useFragment(
        graphql`
            fragment SbSharedNullSearchResultsHeader_itemSearch on ItemSearchQueryConnection {
                searchTerm
            }
        `,
        itemSearchRef
    );
    const { searchTerm } = itemSearch;
    return (
        <>
            <div data-tn="null-results-header" className={styles.results}>
                <FormattedMessage
                    id="sb.SbSharedNullSearchResultsHeader.zeroResults"
                    defaultMessage={`We didn't find any results for "{searchTerm}"`}
                    values={{ searchTerm }}
                />
            </div>
        </>
    );
};
